import store from 'store';
import expirePlugin from 'store/plugins/expire';

store.addPlugin(expirePlugin);

const keys = {
    isAttemptingToSignIn: 'is-attempting-to-sign-in',
    cookieStatement: 'cookie-statement',
    unsupportedModal: 'un-supported-modal',
    currentLanguage: 'current-language',
    utmSourceFirst: 'utm-source-first',
    utmSourceLastTargetedAd: 'utm-source-last-targeted-ad',
    nftFirstTry: 'nft-first-try',
    nftaccesscode: 'nft-access-code',
    nftwalletaddress: 'nft-wallet-address',
    promoType: 'promo-type',
    signupsubscribe: 'sign-up-subscribe',
};

const storeUtils = {
    getIsAttemptingToSignIn: () => store.get(keys.isAttemptingToSignIn),
};

export default storeUtils;
